import L from 'leaflet'

// ─── V2 marker system ─────────────────────────────────────────────────────────
// Category marker symbols — Heroicon SVG paths at 13px inside the pin bulb.
// Designed to be readable at map scale and visually consistent with listing markers.
const ENTITY_CATEGORY_SYMBOLS = {
  food_truck:    'M1.5 8.25a.75.75 0 0 1 .75-.75h19.5a.75.75 0 0 1 0 1.5H2.25a.75.75 0 0 1-.75-.75ZM1.5 15.75a.75.75 0 0 1 .75-.75h11.25a.75.75 0 0 1 0 1.5H2.25a.75.75 0 0 1-.75-.75Zm0-3.75a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75Z',
  ice_cream:     'M12 3a3 3 0 0 0-3 3h6a3 3 0 0 0-3-3Zm-4 6 1.5 9h5L12 9H8Z',
  coffee:        'M2 6h16v2a6 6 0 0 1-6 6H8a6 6 0 0 1-6-6V6Zm16 2h2a2 2 0 0 1 0 4h-2M6 20h8',
  retail:        'M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z',
  service:       'M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437 1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z',
  entertainment: 'M9 9l10.5-3m0 6.553v3.75a2.25 2.25 0 0 1-1.632 2.163l-1.32.377a1.803 1.803 0 1 1-.99-3.467l2.31-.66a2.25 2.25 0 0 0 1.632-2.163Zm0 0V2.25L9 5.25v10.303m0 0v3.75a2.25 2.25 0 0 1-1.632 2.163l-1.32.377a1.803 1.803 0 0 1-.99-3.467l2.31-.66A2.25 2.25 0 0 0 9 15.553Z',
  beverages:     'M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0 1 12 15a9.065 9.065 0 0 0-6.23-.693L5 14.5m14.8.8 1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0 1 12 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5',
  juice_bar:     'M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0 1 12 15a9.065 9.065 0 0 0-6.23-.693L5 14.5m14.8.8 1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0 1 12 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5',
}

// Trust-level ring colors — strictly the app's 3-color palette.
// Ring thickness increases with trust level to reinforce hierarchy visually.
// Primary: #0ABFBC (teal)  |  Accent: #E07B39 (terracotta)  |  Clay: #D4A080
// ring.w = pixel ring width; inner circle = 36 - (w*2) to keep total at 36px.
const TRUST_COLORS = {
  none:   { fill: '#D4A080',             ring: { w: 3, color: '#D4A080' } },
  low:    { fill: 'rgba(10,191,188,0.7)', ring: { w: 3, color: 'rgba(10,191,188,0.7)' } },
  medium: { fill: '#E07B39',             ring: { w: 4, color: '#E07B39' } },
  high:   { fill: '#0ABFBC',             ring: { w: 5, color: '#0ABFBC' } },
}

function getTrustLevel(n) {
  if (n === 0) return 'none'
  if (n === 1) return 'low'
  if (n <= 3) return 'medium'
  return 'high'
}

const v2IconCache = new Map()

// Expose for forced cache clear (e.g. after logo asset update)
export function clearMarkerIconCache() { v2IconCache.clear() }

/**
 * getEntityMarkerIconV2 — SVG teardrop pin (Variant B of A/B test)
 *
 * Visual language cooperates with listing markers:
 *   Entities = teardrop pin  (persistent, tracked community presence)
 *   Listings = filled circle (ephemeral, available-now offers)
 *
 * Trust color progression (app palette, not traffic-light):
 *   0 conf  → slate       “just spotted, uncertain”
 *   1 conf  → amber       “one person confirmed”
 *   2–3 conf → terracotta  “multiple confirmations”  (app accent)
 *   4+ conf → teal        “community-verified” + pulse ring (app primary)
 *
 * @param {Object}  entity             - entity data (.category, .hasBookableOfferings)
 * @param {number}  confirmationCount
 * @param {number}  [opacity=1.0]
 * @returns {L.DivIcon}
 */
export function getEntityMarkerIconV2(entity, confirmationCount = 0, opacity = 1.0) {
  const category  = entity?.category || 'other'
  const hasBookable = !!(entity?.hasBookableOfferings ?? entity?.has_bookable_offerings)
  const imageUrl  = entity?.imageUrl || entity?.image_url || ''
  const hasImage  = imageUrl && imageUrl.startsWith('http')
  const trust     = getTrustLevel(confirmationCount)
  const { fill, ring } = TRUST_COLORS[trust]
  const isVerified = trust === 'high'
  const rw = ring.w                         // ring pixel width
  const innerSize = 36 - rw * 2             // inner circle diameter

  // Cache key: image-bearing markers are per entity ID; symbol markers are shared.
  const entityId  = entity?.entityId || entity?.id || 'unknown'
  const cacheKey  = hasImage
    ? `v2img:${entityId}:${confirmationCount}:${opacity.toFixed(2)}:${hasBookable ? 'svc' : ''}`
    : `v2sym:${category}:${confirmationCount}:${opacity.toFixed(2)}:${hasBookable ? 'svc' : ''}`
  if (v2IconCache.has(cacheKey)) return v2IconCache.get(cacheKey)

  // ── Inner content ─────────────────────────────────────────────────────────
  // Two-div ring pattern — more reliable than CSS border on overflow:hidden divs:
  //   Outer 36px circle  = trust color background (the visible ring)
  //   Inner Npx circle   = white bg + image or logo (centered absolutely)
  //
  // Ring width grows with trust: none=3px, low=3px, medium=4px, high=5px.

  const brandLogo = `<img src="/lg-marker.png"
    style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:${Math.round(innerSize * 0.7)}px;height:auto;pointer-events:none"
    alt="" />`

  // Inner circle: white bg so brand logo / photo sits on a clean surface.
  // For image markers: photo + logo fallback behind it.
  const innerCircle = hasImage
    ? `<div style="width:${innerSize}px;height:${innerSize}px;border-radius:50%;overflow:hidden;position:absolute;top:${rw}px;left:${rw}px;background:white">
         ${brandLogo}
         <img src="${imageUrl}"
              style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover"
              onerror="this.style.display='none'" />
       </div>`
    : `<div style="width:${innerSize}px;height:${innerSize}px;border-radius:50%;overflow:hidden;position:absolute;top:${rw}px;left:${rw}px;background:white">
         ${brandLogo}
       </div>`

  const innerHtml = `<div style="width:36px;height:36px;border-radius:50%;background:${ring.color};box-shadow:0 2px 8px rgba(0,0,0,0.28);position:relative">
    ${innerCircle}
  </div>`

  const badge = hasBookable
    ? `<div style="position:absolute;bottom:-1px;right:-1px;width:11px;height:11px;background:#E07B39;border:2px solid white;border-radius:50%;box-shadow:0 1px 3px rgba(0,0,0,0.35)"></div>`
    : ''

  const pulseClass = isVerified ? ' entity-marker-pulse' : ''

  const icon = L.divIcon({
    html: `<div style="opacity:${opacity};position:relative;width:36px;height:36px" class="entity-marker-v2${pulseClass}">
      ${innerHtml}
      ${badge}
    </div>`,
    iconSize:     [36, 36],
    iconAnchor:   [18, 36],  // bottom-center — points to the location
    popupAnchor:  [0, -40],
    className:    '',
  })

  v2IconCache.set(cacheKey, icon)
  return icon
}


// ─── Legacy PNG system (Variant A) ────────────────────────────────────────────
// Icon configuration
const ICON_CONFIG = {
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
}

// Larger, more visible icon config for user location
const USER_ICON_CONFIG = {
  iconSize: [30, 49],
  iconAnchor: [15, 49],
  popupAnchor: [1, -44],
  shadowSize: [49, 49]
}

// Custom icon for user location - blue marker (closest to primary cyan color)
export const userIcon = new L.Icon({
  iconUrl: '/images/markers/marker-icon-2x-blue.png',
  shadowUrl: '/images/markers/marker-shadow.png',
  ...USER_ICON_CONFIG,
  className: 'user-location-marker'
})

// Custom icon for spot mode — animated pulsing DivIcon (primary teal ring + solid dot)
export const spotModeIcon = L.divIcon({
  className: '',
  html: `<div class="spot-divicon-wrapper"><div class="spot-divicon-ring"></div><div class="spot-divicon-dot"></div></div>`,
  iconSize: [28, 28],
  iconAnchor: [14, 14],
  popupAnchor: [0, -18]
})

// Cached marker icons to avoid recreating identical icons
export const markerIconCache = {
  red: new L.Icon({
    iconUrl: '/images/markers/marker-icon-2x-red.png',
    shadowUrl: '/images/markers/marker-shadow.png',
    ...ICON_CONFIG
  }),
  orange: new L.Icon({
    iconUrl: '/images/markers/marker-icon-2x-orange.png',
    shadowUrl: '/images/markers/marker-shadow.png',
    ...ICON_CONFIG
  }),
  yellow: new L.Icon({
    iconUrl: '/images/markers/marker-icon-2x-yellow.png',
    shadowUrl: '/images/markers/marker-shadow.png',
    ...ICON_CONFIG
  }),
  green: new L.Icon({
    iconUrl: '/images/markers/marker-icon-2x-green.png',
    shadowUrl: '/images/markers/marker-shadow.png',
    ...ICON_CONFIG
  })
}

// Cache for opacity-based divIcons to avoid recreating them
const opacityIconCache = new Map()

/**
 * Get marker icon based on confirmation count with optional label or service badge
 * @param {number}  confirmationCount     - Number of confirmations
 * @param {number}  opacity               - Opacity value between 0 and 1 (default 1.0)
 * @param {string}  label                 - Optional label text to display below marker
 * @param {boolean} hasBookableOfferings  - When true, adds a terracotta service badge dot
 * @returns {L.Icon|L.DivIcon} - Leaflet icon instance
 */
export function getMarkerIcon(confirmationCount, opacity = 1.0, label = null, hasBookableOfferings = false) {
  let baseIcon
  if (confirmationCount === 0) {
    baseIcon = markerIconCache.red // Unconfirmed
  } else if (confirmationCount === 1) {
    baseIcon = markerIconCache.orange // 1 confirmation
  } else if (confirmationCount <= 3) {
    baseIcon = markerIconCache.yellow // 2-3 confirmations
  } else {
    baseIcon = markerIconCache.green // 4+ confirmations (highly trusted)
  }
  
  // If no label, full opacity, and no badge — return the cached base icon
  if (opacity >= 1.0 && !label && !hasBookableOfferings) {
    return baseIcon
  }
  
  // For labeled markers, opacity adjustments, or service badge — create divIcon
  const cacheKey = `${confirmationCount}-${opacity.toFixed(2)}-${label || 'none'}-${hasBookableOfferings ? 'svc' : 'no'}`
  if (opacityIconCache.has(cacheKey)) {
    return opacityIconCache.get(cacheKey)
  }
  
  // Create divIcon with marker and optional label
  const labelHtml = label 
    ? `<div class="marker-label" style="
        position: absolute;
        top: 41px;
        left: 50%;
        transform: translateX(-50%);
        background: white;
        padding: 2px 6px;
        border-radius: 4px;
        font-size: 11px;
        font-weight: 500;
        color: #374151;
        white-space: nowrap;
        box-shadow: 0 1px 3px rgba(0,0,0,0.2);
        pointer-events: none;
        border: 1px solid #e5e7eb;
      ">${label}</div>`
    : ''

  // Small terracotta dot — signals this entity has bookable services
  const serviceBadgeHtml = hasBookableOfferings
    ? `<div style="
        position: absolute;
        bottom: 2px;
        right: -4px;
        width: 10px;
        height: 10px;
        background: #E07B39;
        border: 1.5px solid white;
        border-radius: 50%;
        box-shadow: 0 1px 2px rgba(0,0,0,0.3);
      "></div>`
    : ''
  
  const markerIcon = L.divIcon({
    html: `<div style="opacity: ${opacity}; position: relative;">
      <img src="${baseIcon.options.iconUrl}" style="width: 25px; height: 41px;" />
      ${serviceBadgeHtml}
      ${labelHtml}
    </div>`,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    className: 'custom-marker-with-label'
  })
  
  opacityIconCache.set(cacheKey, markerIcon)
  return markerIcon
}
